// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"cd14438a","258":"cd14438a","628":"cd14438a","848":"84d255bb","881":"cd14438a","962":"cd14438a","968":"cd14438a"}[chunkId] + ".chunk.css";
};